function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * done
 */
import { LoadingOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Upload as AntdUpload, Button } from 'antd';
import cx from 'classnames';
import React, { useMemo, useRef, useState } from 'react';
// @ts-ignore
import { nanoid } from 'nanoid/non-secure';
import { useCssInJs, useMessage, wrapReactionHook } from "../../hooks";
import { useAssistantOssGetPostObjectInfoV1 } from "../../services";
import { Text } from "../Text";
import { genUploadStyle } from "./styles";
var mediaTypeMap = {
  image: 'image/*',
  video: 'video/*',
  'image&video': 'image/*,video/*',
  all: '*/*'
};
export var Upload = wrapReactionHook(function (props) {
  var _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'file' : _props$mode,
    onChange = props.onChange,
    value = props.value,
    maxCount = props.maxCount,
    mediaType = props.mediaType,
    markOnly = props.markOnly,
    readOnly = props.readOnly,
    disabled = props.disabled;
  var loading = false;
  var prefix = 'upload';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genUploadStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var getOSSData = useAssistantOssGetPostObjectInfoV1();
  var defaultFileList = useMemo(function () {
    return Array.isArray(value) ? value.filter(function (item) {
      return item === null || item === void 0 ? void 0 : item.url;
    }).map(function (item) {
      return {
        name: item.name,
        status: 'done',
        url: item.url,
        uid: item.url
      };
    }) : [];
  }, [value]);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var ossRef = useRef({
    expires: 0,
    accessId: '',
    dir: '',
    downloadUrl: '',
    policy: '',
    signature: '',
    uploadHost: ''
  });
  var message = useMessage();
  var init = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            ossRef.current = null;
            _context.next = 3;
            return getOSSData();
          case 3:
            result = _context.sent;
            if (result.code === 0 && result.data) {
              ossRef.current = result.data;
            } else {
              message.error(result.msg);
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function init() {
      return _ref.apply(this, arguments);
    };
  }();
  var getOssEndPoint = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (ossRef.current) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return getOSSData();
          case 3:
            return _context2.abrupt("return", ossRef.current.uploadHost);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getOssEndPoint() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleChange = function handleChange(_ref3) {
    var file = _ref3.file,
      fileList = _ref3.fileList,
      event = _ref3.event;
    if (file.status === 'removed') {
      return;
    }
    // console.log('upload', file, fileList, event)
    var doneList = [];
    var progressList = [];
    fileList.forEach(function (task) {
      if ('objectName' in task) {
        if (task.status === 'done') {
          doneList.push(task);
        } else {
          progressList.push(task);
        }
      }
    });
    setList(progressList);
    onChange([].concat(_toConsumableArray(defaultFileList.map(function (item) {
      return {
        name: item.name,
        url: item.url
      };
    })), _toConsumableArray(doneList.map(function (item) {
      return {
        name: item.name,
        url: item.url
      };
    }))));
  };
  var onRemove = function onRemove(file) {
    // console.log('remove', file)
    var idx = defaultFileList.findIndex(function (i) {
      return i.uid === file.uid;
    });
    if (idx !== -1) {
      var nextList = _toConsumableArray(defaultFileList);
      nextList.splice(idx, 1);
      onChange(nextList.map(function (item) {
        return {
          name: item.name,
          url: item.url
        };
      }));
      return;
    }
    idx = list.findIndex(function (i) {
      return i.uid === file.uid;
    });
    if (idx !== -1) {
      var _nextList = _toConsumableArray(list);
      _nextList.splice(idx, 1);
      setList(_nextList);
    }
  };
  var getExtraData = function getExtraData(file) {
    var _ossRef$current, _ossRef$current2, _ossRef$current3;
    return {
      // @ts-ignore
      key: file.key,
      OSSAccessKeyId: (_ossRef$current = ossRef.current) === null || _ossRef$current === void 0 ? void 0 : _ossRef$current.accessId,
      policy: (_ossRef$current2 = ossRef.current) === null || _ossRef$current2 === void 0 ? void 0 : _ossRef$current2.policy,
      Signature: (_ossRef$current3 = ossRef.current) === null || _ossRef$current3 === void 0 ? void 0 : _ossRef$current3.signature
    };
  };
  var beforeUpload = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
      var expire, objectName, key;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (ossRef.current) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", false);
          case 2:
            expire = +ossRef.current.expires;
            if (!(expire < Date.now())) {
              _context3.next = 6;
              break;
            }
            _context3.next = 6;
            return init();
          case 6:
            if (ossRef.current) {
              _context3.next = 8;
              break;
            }
            return _context3.abrupt("return", false);
          case 8:
            objectName = "web/".concat(nanoid(), "/").concat(file.name);
            key = "".concat(ossRef.current.dir).concat(objectName); // @ts-ignore
            file.key = key;

            // @ts-ignore
            file.objectName = objectName;

            // @ts-ignore
            file.url = "".concat(ossRef.current.downloadUrl).concat(encodeURIComponent(objectName));

            // @ts-ignore
            file.uid = file.url;
            return _context3.abrupt("return", file);
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function beforeUpload(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var uploadButton = /*#__PURE__*/React.createElement("div", {
    className: cx("".concat(prefix, "-picture-button"), hashId)
  }, loading ? /*#__PURE__*/React.createElement(LoadingOutlined, null) : /*#__PURE__*/React.createElement(PlusOutlined, null), /*#__PURE__*/React.createElement("div", {
    className: cx("".concat(prefix, "-picture-text"), hashId)
  }, "\u6DFB\u52A0"));
  return wrapSSR( /*#__PURE__*/React.createElement(AntdUpload, {
    accept: mediaTypeMap[mediaType] || '*/*',
    name: "file",
    listType: mode === 'file' ? 'text' : 'picture-card',
    maxCount: maxCount,
    fileList: [].concat(_toConsumableArray(defaultFileList), _toConsumableArray(list)),
    action: getOssEndPoint,
    onChange: handleChange,
    onRemove: onRemove,
    data: getExtraData,
    beforeUpload: beforeUpload,
    className: cx(prefix, hashId),
    disabled: readOnly || markOnly || disabled
  }, markOnly ? /*#__PURE__*/React.createElement(Text, null, "\u8BF7\u4F7F\u7528\u3010\u7C73\u6751\u52A9\u624B\u3011\u5C0F\u7A0B\u5E8F\u5904\u7406\u6B64\u4EFB\u52A1") : null, markOnly || readOnly || defaultFileList.length + list.length >= maxCount ? null : /*#__PURE__*/React.createElement(React.Fragment, null, mode === 'file' ? /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(UploadOutlined, null)
  }, /*#__PURE__*/React.createElement("span", {
    className: cx("".concat(prefix, "-file-text"), hashId)
  }, "\u9009\u62E9\u6587\u4EF6\u5E76\u4E0A\u4F20")) : null, mode === 'picture' ? uploadButton : null)));
});